<small class="debug">{{me}}</small>
<div mat-dialog-content>
  <button style="position: relative; top: -5px" class="pull-right mini-button" mat-icon-button cdkFocusInitial [mat-dialog-close]="someVar" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
  @if (ready && totalOf > 1) {
    <div fxLayout="row" fxLayoutAlign="space-around center">
      <button mat-button (click)="prev()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span  style="text-align: center">{{flick.index + 1}} of {{totalOf}}</span>
      <button class="pull-right" mat-button (click)="next()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  }

  <ngx-flicking #flicking style="height: 100%; width: 100%">
    @for (t of images; track t; let index = $index) {
      <div flicking-panel class="panel">
        <div class="item active">
          @if (imageLoading) {
            <div style="height: 250px; padding-top: 100px;">
              <app-loading [type]="-1" [size]="'60px'"></app-loading>
            </div>
          }
          <div [hidden]="imageLoading" style="width: 100%; text-align: center">
            <img [src]="t" (load)="onLoad()" style="height: 100%; width: 100%" loading="eager"/>
          </div>
        </div>
      </div>
    }
    @for (t of videos; track t; let index = $index) {
      <div flicking-panel class="panel">
        <div class="item active">
          <div style="width: 100%; text-align: center">
            <vg-player>
              <vg-controls>
                <vg-play-pause></vg-play-pause>
                <vg-playback-button></vg-playback-button>
                <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
                <vg-scrub-bar>
                  <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                  <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                </vg-scrub-bar>
                <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>
                <vg-mute></vg-mute>
                <vg-volume></vg-volume>
                <vg-fullscreen></vg-fullscreen>
              </vg-controls>
              <video  [vgMedia]="$any(media)" #media [autoplay]="true" preload="auto">
                <source src="{{t}}" type="video/mp4">
              </video>
            </vg-player>
          </div>
        </div>
      </div>
    }
  </ngx-flicking>
</div>
